<template>
  <div>
    <section v-if="content.body.length">
      <div class="pt-5">
        <div class="d-flex">
          <div class="flex-grow-1">
            <div class="headline" v-text="content.title"></div>
          </div>
          <template>
            <div class="flex-shrink-1">
              <v-btn
                class="text-capitalize"
                text
                :color="$buttonColor"
                @click="more()"
              >
                See More
                <v-icon right small>far fa-chevron-right</v-icon>
              </v-btn>
            </div>
          </template>
        </div>
        <div
          class="subtitle-1 grey--text text--darken-2"
          v-text="content.subtitle"
        ></div>
      </div>

      <horizontal-scroll class="horizontal-scroll">
        <v-row class="outer px-0">
          <template v-for="item of content.body">
            <v-col
              cols="6"
              sm="6"
              md="4"
              lg="4"
              xl="4"
              class="pr-5 my-course-card"
              :key="`my_course_${item._id}`"
              @click="navigate(item)"
            >
              <v-hover v-slot:default="{ hover }">
                <v-card
                  class="myCourseCustomCard hoverable card-growable"
                  elevation="0"
                  height="auto"
                  @click="navigate(item)"
                >
                  <v-row>
                    <v-col cols="4">
                      <v-img
                        class="myCourseImage"
                        :src="item.image"
                        aspect-ratio="1"
                      >
                      </v-img>
                    </v-col>
                    <v-col cols="8">
                      <v-list two-line class="pa-0">
                        <template>
                          <v-list-item :key="item.title" class="pa-0">
                            <template v-slot:default="{ active }">
                              <v-list-item-content class="pa-0">
                                <v-list-item-subtitle
                                  :style="{
                                    color: `${$themeColor}`,
                                    fontSize: `13px`,
                                    fontWeight: `500`,
                                    marginTop: `8px`,
                                    marginBottom: `8px`,
                                  }"
                                  >{{
                                    item.categories[0].title
                                  }}</v-list-item-subtitle
                                >
                                <v-list-item-title
                                  class="myCourseTitle"
                                  v-text="item.title"
                                ></v-list-item-title>
                                <div class="py-2">
                                  <v-progress-linear
                                    :value="item.percent"
                                    color="success"
                                    :height="10"
                                    class="customProgressbar"
                                  ></v-progress-linear>
                                </div>
                                <div class="myCourseProcess">
                                  Progress ( {{ item.percent }}% )
                                </div>
                              </v-list-item-content>
                            </template>
                          </v-list-item>
                        </template>
                      </v-list>
                    </v-col>
                  </v-row>
                </v-card>
              </v-hover>
            </v-col>
          </template>

          <!-- <v-col cols="12" sm="6" lg="4" xl="3" class="pr-5">
        <v-hover v-slot:default="{ hover }">
          <v-card
            class="myCourseCustomCard hoverable card-growable"
            elevation="0"
            ripple=""
          >
            <v-row>
              <v-col cols="auto">
                <v-img
                  class="myCourseImage"
                  src="https://s3-amr.deknerd.com/template/certificates/certificate1.png"
                >
                </v-img>
              </v-col>
              <v-col>
                <div class="myCourseCatagory">Catagory</div>
                <div class="myCourseTitle">Title</div>
                <div class="py-2">
                  <v-progress-linear
                    value="85"
                    color="#afce8c"
                    height="10px"
                    class="customProgressbar"
                  ></v-progress-linear>
                </div>
                <div class="myCourseProcess">Process ( 85% )</div>
              </v-col>
            </v-row>
          </v-card>
        </v-hover>
      </v-col>
      <v-col cols="12" sm="6" lg="4" xl="3" class="pr-5">
        <v-hover v-slot:default="{ hover }">
          <v-card
            class="myCourseCustomCard hoverable card-growable"
            elevation="0"
            ripple=""
          >
            <v-row>
              <v-col cols="auto">
                <v-img
                  class="myCourseImage"
                  src="https://s3-amr.deknerd.com/template/certificates/certificate1.png"
                >
                </v-img>
              </v-col>
              <v-col>
                <div class="myCourseCatagory">Catagory</div>
                <div class="myCourseTitle">Title</div>
                <div class="py-2">
                  <v-progress-linear
                    value="85"
                    color="#afce8c"
                    height="10px"
                    class="customProgressbar"
                  ></v-progress-linear>
                </div>
                <div class="myCourseProcess">Process ( 85% )</div>
              </v-col>
            </v-row>
          </v-card>
        </v-hover>
      </v-col> -->
          <!-- <v-col cols="12" sm="6" lg="4" xl="3" class="pr-5">
        <v-hover v-slot:default="{ hover }">
          <v-card
            class="myCourseCustomCard hoverable card-growable"
            elevation="0"
            ripple=""
            style="height: 138px"
          >
            <v-row>
              <v-col>
                <div
                  align="center"
                  class="text-capitalize pt-10"
                  style="font-size: 16px; color: #4a90e2; font-weight: bold"
                >
                  See More >
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-hover>
      </v-col> -->
        </v-row>
      </horizontal-scroll>
    </section>
    <section v-else>
      <div class="mb-2 pt-5">
        <div class="d-flex">
          <div class="flex-grow-1">
            <div class="headline" v-text="content.title"></div>
          </div>
        </div>
        <div
          class="subtitle-1 grey--text text--darken-2"
          v-text="content.subtitle"
        ></div>
      </div>
      <v-row class="px-2 mb-4 text-center body-2 grey--text">
        <v-col cols="12"> ไม่มีข้อมูล </v-col>
      </v-row>
    </section>
  </div>
</template>

<script>
import HorizontalScroll from "vue-horizontal-scroll";
import "vue-horizontal-scroll/dist/vue-horizontal-scroll.css";
export default {
  name: "my_course_vertical_gridview",
  components: {
    HorizontalScroll,
  },
  props: {
    content: {
      type: Object,
    },
  },
  data() {
    return {
      arrayMyCourse: [],
    };
  },
  mounted() {
    // this.initialize();
    console.log(this.content);
    // this.myCourseCatagory();
  },
  computed: {
    //   myCourseCatagory {
    // font-size: 13px;
    // font-weight: 500;
    // color: #4a90e2;
    // myCourseCatagory() {
    //   return {
    //     fontsize: `13px`,
    //     fontweight: `500`,
    //     color: `${themeColor}`,
    //   };
    // },
  },
  methods: {
    // initialize() {
    //   this.content.body.forEach(course, (index) => {
    //     this.arrayMyCourse.push({ course });
    //   });
    //   console.log(this.arrayMyCourse);
    // },
    more() {
      // const qs = this.$utility.queryStringToJson(
      //   flag == "footer"
      //     ? this.content.footerButton.queries
      //     : this.content.headerButton.queries
      // );
      const qs = this.content.footerButton
        ? this.content.footerButton.queries
        : this.content.headerButton.queries;
      console.log(qs);
      let sorting = qs.filter((query) => query.param == "sort")[0].value;
      let sortingby = qs.filter((query) => query.param == "sortby")[0].value;
      let searching = qs.filter((query) => query.param == "search")[0];
      console.log(sortingby);
      console.log(searching);
      if (searching) {
        searching = searching.value;
      } else {
        searching = null;
      }
      this.$router.push({
        name: "my_course",
        query: {
          sort: sorting,
          sortby: sortingby,
          page: 1,
          limit: 10,
          title: this.content.title,
          search: searching,
        },
      });
    },
    navigate(item) {
      this.$router.push({
        name: "course_detail",
        params: {
          id: item._id,
        },
      });
    },
    eventSlider() {
      console.log("event");
      const rightBtn = document.querySelector("#right-button");
      const leftBtn = document.querySelector("#left-button");

      rightBtn.addEventListener("click", function (event) {
        const conent = document.querySelector("#content");
        conent.scrollLeft += 500;
        event.preventDefault();
      });

      leftBtn.addEventListener("click", function (event) {
        const conent = document.querySelector("#content");
        conent.scrollLeft -= 500;
        event.preventDefault();
      });
    },
  },
};
</script>
<style scoped>
.myCourseCustomCard {
  border-radius: 8px;
  border: solid 1px #dcdcdc;
  background-color: #ffffff;
  padding: 15px 15px 15px 15px;
}
.myCourseImage {
  width: 100px;
  height: 100px;
  border-radius: 8px;
}
.myCourseCatagory {
  font-size: 13px;
  font-weight: 500;
  color: #4a90e2;
}
.myCourseTitle {
  font-size: 16px;
  font-weight: bold;
  line-height: 1.38;
  color: #4a4a4a;
  margin-bottom: 0px;

  display: block;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  /* min-height: 35px;
  max-height: 43px; */
}

.myCourseProcess {
  font-size: 12px;
  color: #9b9b9b;
}

.customProgressbar {
  border-radius: 5px;
  border: solid 1px #ffffff;
  background-color: #f2f2f2;
}

.theme--light.v-list-item .v-list-item__subtitle {
  color: none;
}

.horizontal-scroll {
  display: flex;
  width: 100%;
  /* height: 150px; */
}

.outer {
  display: flex;
  flex: 1;
  width: auto;
  /* height: 100%; */
  padding: 20px;
  flex-flow: row nowrap;
  align-items: center;
}
.inner-content {
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: calc(100% - 40px);
  border-radius: 5px;
}
.inner-content:not(:first-of-type) {
  margin-left: 30px;
}
@media only screen and (max-width: 480px) {
  .my-course-card {
    flex: 0 0 90vw;
    max-width: 90vw;
  }
}
</style>
